// Shopify analytics — dev-only until the Shopify launch (like the Shopify connect pages).
// No `feature` key: the Amazon marketplace capability gates do not apply to a Shopify
// store. The route itself is hard-blocked outside development by devOnlyPaths in
// src/router/index.js.
const item = (title, to, icon) => ({
  title,
  action: 'read',
  subject: 'User',
  to,
  icon: { icon },
  envOnly: 'development',
});

export default [
  {
    title: 'Shopify',
    channel: 'shopify',
    icon: { icon: 'selfhst:shopify' },
    envOnly: 'development',
    children: [
      item('Overview', 'shopify-overview', 'ic:outline-dashboard'),
      item('Sales Explorer', 'shopify-sales-explorer', 'ic:outline-insights'),
      item('Inventory', { name: 'shopify-inventory-tab', params: { tab: 'stock-health' } }, 'ic:outline-inventory-2'),
      item('Order Attribution', 'shopify-order-attribution', 'ic:outline-campaign'),
      item('Blog Comments', 'shopify-article-comments', 'ic:outline-comment'),
      item('Customers', 'shopify-customers', 'ic:outline-people'),
      item('Customer Addresses', 'shopify-customer-addresses', 'ic:outline-location-on'),
      item('Transactions', 'shopify-transactions', 'ic:outline-account-balance-wallet'),
      item('SKU Map', { name: 'shopify-sku-map-tab', params: { tab: 'matched' } }, 'ic:outline-compare-arrows'),
      item('Collections', 'shopify-collections', 'ic:outline-collections-bookmark'),
    ],
  },
];
